/**
 * Test IDs for QA automation.
 */
export const testIds = {
  customFieldsListCreateField: "custom-fields-list-create-field",
} as const;
